module.exports = __webpack_public_path__ + "img/publish-landing.a3d956aa.png";